import { Document, Page, Text, View } from "@react-pdf/renderer";
import React from "react";
import { IntlProvider } from "react-intl";
import { borderStyleGray, styles } from "../reportingHelpers";
import {
  buildPlayerLookup,
  calculateCardsFromPbp,
  processScoringIntervals,
} from "./helpers";
import MatchInfo from "./MatchInfo";
import SeasonHeader from "./SeasonHeader";
import TeamCardsDetails from "./TeamCardsDetails";
import TeamsAndScores from "./TeamsAndScores";

const HockeyCardsReport = ({ data, intl, locale }) => {
  const {
    fixture,
    fixtureProfile: { profile: fixtureProfile },
    playByPlay,
    roles,
    scoringIntervals,
    teams,
  } = data;
  const homeTeamId = Object.keys(teams).find((id) => teams[id].isHome);
  const awayTeamId = Object.keys(teams).find((id) => !teams[id].isHome);
  const playerLookup = {
    [homeTeamId]: buildPlayerLookup(teams[homeTeamId].players),
    [awayTeamId]: buildPlayerLookup(teams[awayTeamId].players),
  };
  const intervals = processScoringIntervals(
    scoringIntervals,
    homeTeamId,
    awayTeamId
  );
  const cards = calculateCardsFromPbp(playByPlay, fixtureProfile);
  const technicalOfficer = roles.find((r) => r.role === "TECHNICAL_OFFICIAL");

  return (
    <IntlProvider locale={locale ?? "en-US"}>
      <Document>
        <Page
          size="A4"
          orientation="portrait"
          style={{ ...styles.page, fontFamily: ["Noto Sans", "Noto Sans TC"] }}
          wrap={false}
        >
          <SeasonHeader fixture={fixture} />
          <MatchInfo
            intl={intl}
            fixture={fixture}
            matchLabel="reports.cardsReport"
          />
          <TeamsAndScores
            intl={intl}
            scoringIntervals={intervals}
            teams={teams}
          />
          <View
            style={{ flexDirection: "column", justifyContent: "space-between" }}
          >
            <TeamCardsDetails
              cards={cards[homeTeamId]}
              intl={intl}
              players={playerLookup[homeTeamId]}
              teamName={teams[homeTeamId].name}
            />
            <TeamCardsDetails
              cards={cards[awayTeamId]}
              intl={intl}
              players={playerLookup[awayTeamId]}
              teamName={teams[awayTeamId].name}
            />
          </View>
          <Text
            style={{
              fontSize: "7",
              textAlign: "center",
              marginTop: 6,
              marginBottom: 6,
            }}
          >
            {intl.formatMessage({
              id: "reports.cardsReport.duration.note",
              defaultMessage: "A note",
            })}
          </Text>
          <View
            style={{
              flexDirection: "column",
              width: "50%",
              border: borderStyleGray,
              padding: 4,
              height: 40,
              justifyContent: "space-between",
              fontSize: 10,
              alignSelf: "center",
            }}
          >
            <Text style={{ fontSize: 8 }}>Technical Officer</Text>
            <Text style={{ fontSize: 10, fontWeight: "bold" }}>
              {technicalOfficer?.name ?? "-"}
            </Text>
          </View>
        </Page>
      </Document>
    </IntlProvider>
  );
};

export default HockeyCardsReport;
